// extracted by mini-css-extract-plugin
module.exports = {"root":"_82b0ea","itemWrapper":"_d3da10","item":"_a16fde","list":"_35e73d","separator":"_56f72d"};